import { Announcement, AnnouncementStatus, PropertyType, AnnouncementType, OwnerType } from './announcement.model';
import { ResidentialComplex, Banner } from './home.model';

export const MOCK_COMPLEXES: ResidentialComplex[] = [
  {
    id: 'c1',
    name: 'Sea Breeze Lighthouse',
    developer: 'Sea Breeze',
    minPrice: 272900,
    pricePerM2: 1850,
    location: 'Nardaran',
    status: 'Tikilməkdədir',
    deliveryYear: 2025,
    mainImage: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=800&q=80'
  },
  {
    id: 'c2',
    name: 'Park Residence',
    developer: 'Gilan Holding',
    minPrice: 150000,
    pricePerM2: 2100,
    location: 'Nərimanov r.',
    status: 'Hazırdır',
    deliveryYear: 2023,
    mainImage: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800&q=80'
  },
  {
    id: 'c3',
    name: 'White City Towers',
    developer: 'Baku White City',
    minPrice: 320000,
    pricePerM2: 2500,
    location: 'Xətai r.',
    status: 'Tikilməkdədir',
    deliveryYear: 2026,
    mainImage: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80'
  },
  {
    id: 'c4',
    name: 'Port Baku Residence',
    developer: 'Pasha Construction',
    minPrice: 550000,
    pricePerM2: 4500,
    location: 'Səbail r.',
    status: 'Hazırdır',
    deliveryYear: 2015,
    mainImage: 'https://images.unsplash.com/photo-1449156003053-c30670b96835?auto=format&fit=crop&w=800&q=80'
  },
  {
    id: 'c5',
    name: 'Yasamal MTK',
    developer: 'Kristal Abşeron',
    minPrice: 85000,
    pricePerM2: 1200,
    location: 'Yasamal r.',
    status: 'Hazırdır',
    deliveryYear: 2022,
    mainImage: 'https://images.unsplash.com/photo-1460317442991-0ec23939714e?auto=format&fit=crop&w=800&q=80'
  }
];

export const MOCK_ANNOUNCEMENTS: Announcement[] = Array.from({ length: 100 }, (_, i) => ({
  id: i + 1,
  title: `${i % 3 + 1} otaqlı mənzil`,
  status: AnnouncementStatus.Active,
  price: 50000 + Math.floor(Math.random() * 500000),
  area_m2: 40 + Math.floor(Math.random() * 150),
  rooms: (i % 4) + 1,
  floor: (i % 12) + 1,
  total_floors: 16,
  address: 'Atatürk prospekti',
  region: 'Nərimanov r.',
  propertyType: i % 2 === 0 ? PropertyType.NewBuild : PropertyType.OldBuild,
  type: i % 5 === 0 ? AnnouncementType.Rent : AnnouncementType.Sale,
  ownerType: i % 3 === 0 ? OwnerType.Agent : OwnerType.Owner,
  hasExtract: i % 2 === 0,
  hasMortgage: i % 3 === 0,
  description: 'Gözəl mənzərəli mənzil təcili satılır.',
  createdAt: new Date(),
  expiresAt: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
  imageUrls: ['https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=800&q=80'],
  contactName: 'Əli',
  contactPhone: '+994 50 123 45 67',
  isVip: i < 20,
  lat: 40.4093,
  lng: 49.8671,
  viewCount: Math.floor(Math.random() * 1000)
}));

export const MOCK_BANNERS: Banner[] = [
  {
    id: 'b1',
    imageUrl: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=320&h=1200&q=80',
    link: 'https://google.com',
    type: 'external',
    position: 'left'
  },
  {
    id: 'b2',
    imageUrl: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=320&h=1200&q=80',
    link: '/listings/a1',
    type: 'listing',
    position: 'right'
  }
];
